import { useState } from "react";
import Filters from "./filters";
import Table from "./table";

const DeliverySearch = () => {
  const [filters, setFilters] = useState(null);

  return (
    <>
      <div className="app-content-header">
        <div style={{ width: "100%", padding: "12px 24px" }}>
          <Filters onChange={setFilters} />
        </div>
      </div>
      <div className="nav-page-content">
        {filters ? (
          <Table filters={filters} />
        ) : (
          <div>
            Gönderi sorgulayabilmek için lütfen üst bölümde yer alan barkod
            bölümüne gönderi barkodunu yazdıktan sonra ara butonuna tıklayınız.
          </div>
        )}
      </div>
    </>
  );
};

export default DeliverySearch;
